import { Injectable } from '@angular/core';
import { config } from '../../config/config';
import { getEnv } from '../utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';
import { PageOptions } from 'src/app/shared/data-table/data-table.interface';

@Injectable()
export class ViewUpdateTprApiService {


    constructor(
        private readonly http: BaseHttpService
    ) { }

    public getTpr(body, pageOptions: PageOptions = {
        page: 0,
        size: 10,
        order: 'asc',
        sort: 'programName'
    }, tprActive = true) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tpr-grid${body.reSourced ? '-resourced' : ''}?`
            + `page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`
            + `&tprActive=${tprActive}`;
        return this.http.post(url, body);
    }

    public getInactiveTpr(body, pageOptions: PageOptions = {
        page: 0,
        size: 10,
        order: 'asc',
        sort: 'programName'
    }, tprActive = false) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tpr-grid?`
            + `page=${pageOptions.page}&size=${pageOptions.size}&sort=${pageOptions.sort}&order=${pageOptions.order}`
            + `&tprActive=${tprActive}`;
        return this.http.post(url, body);
    }

    public getIndividualTpr(toolNo) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tpr?toolNo=${toolNo}`;
        return this.http.get(url);
    }

    public getIndividualToolById(tprToolId: number) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tpr/${tprToolId}`;
        return this.http.get(url);
    }

    public activateTpr(toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}maint/tpr?toolId=${toolId}`;
        return this.http.put(url, null);
    }
    public addTpr(body) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tpr-tool`;
        return this.http.post(url, body);
    }

    public duplicateTpr(newToolNo, toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/duplicate?newToolNo=${newToolNo}&toolId=${toolId}`;
        return this.http.post(url);
    }

    public duplicateRevTpr(newToolNo, toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/duplicate-rev?newToolNo=${newToolNo}&toolId=${toolId}`;
        return this.http.post(url);
    }

    public updateGenericTprField(body) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/generic-field`;
        return this.http.put(url, body);
    }

    public updateSpecificTprField(body) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/specific-field`;
        return this.http.put(url, body);
    }

    public updateTprGrid(body, tprToolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/grid?tprToolId=${tprToolId}`;
        return this.http.put(url, body);
    }

    public updateTprResource(toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tool/resourced/${toolId}`;
        return this.http.put(url, null);
    }

    public undoTprResource(toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tool/undo-resourced/${toolId}`;
        return this.http.put(url, null);
    }

    public printTpr(toolId) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/print?tprToolId=${toolId}`;
        return this.http.get(url);
    }

    public deleteTool(id) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}tpr/tool/soft-delete/${id}`;
        return this.http.put(url, null);
    }

    getDesignSource() {
        return this.get('tpr/criteria/design-source');
    }

    getConstSource() {
        return this.get('tpr/criteria/const-source');
    }

    getFirstUserSource() {
        return this.get('tpr/criteria/first-user-source');
    }

    getUserSource() {
        return this.get('tpr/criteria/user-source');
    }

    getfixtureLocation() {
        return this.get('tpr/criteria/fixture-location');
    }

    private get(path) {
        const url = `${config.tprecmApiBaseUrl[getEnv()]}${path}`;
        return this.http.get(url);
    }
}
